module.exports = __webpack_public_path__ + "static/media/arymite.4c9e4af9.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/manzano/climasense/acaro_manzano/curativa/arymite.png
// module id = 1742
// module chunks = 3